import { useMemo } from 'react';

import { Actions } from '#/components/PlanPurchaseFlow/types';
import { paywallActions, usePaywall } from '#/store/paywall';

// most of the things were already removed from here. maybe we can remove the whole thing later.
export const usePlanPickerActions = (): Actions => {
  const { closeHandler } = usePaywall();

  return useMemo(
    () => ({
      handleError: paywallActions.setError,
      handleClose: () => {
        if (!closeHandler?.isCancelOnly) {
          closeHandler?.onClose();
        }

        if (!closeHandler?.ignoreDefault) {
          paywallActions.closePaywall();
        }
      },
    }),
    [closeHandler]
  );
};
